import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Select from 'react-select'
import { changeLocale } from '@app/actions/global'
import landingDefaultTheme from './styles/landingDefaultTheme'
import _ from 'lodash'

const themeProps = {
  default: landingDefaultTheme,
  'landing-header': Object.assign({}, landingDefaultTheme, {
    container: (provided, state) => (
      { ...provided, 
        width: "124px",
        '@media only screen and (max-width: 450px)': {
          "width": "100px"
        }, 
      }),
    menuList: (provided, state) => (
      { ...provided, 
        "max-height": "280px",
        "width": "100px"
      }),
    menu: (provided, state) => (
      { ...provided, "padding": "1px" }
    ),
    singleValue: (provided, state) => (
      { ...provided,
        "color": "#fff",
        "text-decoration": "underline"
      }
    ),
    option: (provided, state) => (
      { ...provided, "color": state.isFocused ? "white" : "black" }
    ),
    control: (provided, state) => (
      { ...provided,
        "border": "none",
        "outline": "none",
        "box-shadow": "none",
        "background-color": "#2491DF",
      }
    ),
    dropdownIndicator: (provided, state) => (
      { ...provided, "display": "none" }
    ),
  }),
  landing: Object.assign({}, landingDefaultTheme, {
    container: (provided, state) => ({ ...provided, width: "124px" }),
    menuList: (provided, state) => ({ ...provided, "max-height": "280px" })
  })
}

class LanguageSelect extends Component {
  constructor(props) {
    super(props)

    this.handleLanguageChange = this.handleLanguageChange.bind(this)
  }

  handleLanguageChange(selectedOption) {
    if (!selectedOption) { return }

    const { onChange, boundedChanger } = this.props
    const handler = onChange || boundedChanger

    handler(selectedOption.code)
  }

  get selectedLanguage() {
    const { languages, value } = this.props
    return _.find(languages, ['code', value || I18n.locale])
  }

  render() {
    const { languages, theme } = this.props
    return (
      <Select
        options={languages}
        onChange={this.handleLanguageChange}
        value={this.selectedLanguage}
        getOptionLabel={(option) => option.name}
        getOptionValue={(option) => option.code}
        styles={themeProps[theme]}
        isSearchable={false}
      />
    )
  }
}

LanguageSelect.propTypes = {
  languages: PropTypes.array.isRequired,
  onChange: PropTypes.func,
  value: PropTypes.string
}

LanguageSelect.defaultProps = {
  theme: "default"
}

const mapDispatchToProps = (dispatch) => {
  const boundedChanger = bindActionCreators(changeLocale, dispatch)
  return { boundedChanger }
}

export default connect(null, mapDispatchToProps)(LanguageSelect)
